import React, { useState } from "react";

import BreakReasonStartDialog from "./break-reason-start-dialog";
import { MenuItem } from "@mui/material";

import { Timer as TimerIcon } from '@mui/icons-material';
import BreakReasonTimer from "./break-reason-timer";

const defaultState = {
	loading: false,
	openDialog: false,
};

export default function BreakReason({
	intl,
	classes,
	handleClose,
	setState,
	loading
}) {
	const [internalState, setInternalState] = useState(defaultState);

	function handleOpenOrCloseDialog() {
		setInternalState(prevState => ({ ...prevState, openDialog: !prevState.openDialog }));
	}

	function handleOpenEndBreakDialog() {
		handleClose();

		handleOpenOrCloseDialog();
	}

	return (
		<React.Fragment>
			<BreakReasonTimer
				onBeforeEndBreak={handleClose}
				timerStyleType="header"
				setState={setState}
				simple
			>
				<MenuItem key={1} onClick={handleOpenEndBreakDialog}>
					<TimerIcon />
					<span style={{ marginLeft: '10px' }}>{intl.formatMessage({ id: "menu.register.break" })}</span>
				</MenuItem>
			</BreakReasonTimer>

			<BreakReasonStartDialog
				open={internalState.openDialog}
				handleOpenOrClose={handleOpenOrCloseDialog}
				classes={classes}
				setState={setState}
				loading={loading}
			/>
		</React.Fragment>
	)
}